<div id="lightboxMessage" class="light-box1" *ngIf="isShowTimeOutDialog">
    <div class="modal-box no-padding width-40">
        <div class="modal-header header-danger-gov">
            <h3 class="text-align-center text-bold">
                הפרטיות שלך חשובה לנו
            </h3>
        </div>
        <div class="modal-body">
            <p class="margin-bottom-md"  >
                <span class="breakword"[innerHTML]="'timeOut.timeoutMessage'|translate">   </span>
</p>
        </div>
        <div class=" text-align-center row col-md-12 col-xs-12" >
            <div class="col-md-6 col-xs-6">
                <button (click)="cancel()" class="btn btn-primary-gov  pull-right fa-display-center">המשך</button>
            </div>
            <div class="col-md-6 col-xs-6">
                <button (click)="exit()" class="btn btn-primary-gov  pull-left fa-display-center">יציאה</button>
            </div>
        </div>
    </div>
</div>